import { graphql } from 'parkdepot-shared/gql'

export const OrderPriceResponseFragment = graphql(`
    fragment B2COrderPriceResponse on B2CCarpayOrderView {
        price {
            price_valid_until
            parking_price
            illegal_parking_price
            discounted_parking_price
            applied_discount
        }
    }
`)

const B2C_GET_ORDER_PRICE = graphql(`
    query B2CGetOrderPrice($order_id: String!, $selected_parking_tariff: String!, $parking_context_uuid: String) {
        b2c_get_price(
            order_id: $order_id
            selected_parking_tariff: $selected_parking_tariff
            parking_context_uuid: $parking_context_uuid
        ) {
            ...B2COrderPriceResponse
        }
    }
`)

export default B2C_GET_ORDER_PRICE
